import { render } from "./ZoomSignature.vue?vue&type=template&id=68877941"
import script from "./ZoomSignature.vue?vue&type=script&lang=js"
export * from "./ZoomSignature.vue?vue&type=script&lang=js"
script.render = render

export default script